import { Outlet } from 'react-router-dom';

export const InvestorProfile = () => {
	return <Outlet></Outlet>;
};
